import { render, staticRenderFns } from "./AffiliateRegisteredUserTable.vue?vue&type=template&id=44b78154&scoped=true&"
import script from "./AffiliateRegisteredUserTable.vue?vue&type=script&lang=babel&"
export * from "./AffiliateRegisteredUserTable.vue?vue&type=script&lang=babel&"
import style0 from "./AffiliateRegisteredUserTable.vue?vue&type=style&index=0&id=44b78154&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b78154",
  null
  
)

export default component.exports